/* -------------------------------------------------------------
 * 1) CSS-like easing for jQuery (cubic-bezier(0.25, 0.1, 0.25, 1))
 * ----------------------------------------------------------- */
(function ($) {
  function cubicBezier(mX1, mY1, mX2, mY2) {
    var NEWTON_ITERATIONS = 4, NEWTON_MIN_SLOPE = 0.001,
        SUBDIVISION_PRECISION = 1e-7, SUBDIVISION_MAX_ITERATIONS = 10,
        kSplineTableSize = 11, kSampleStepSize = 1 / (kSplineTableSize - 1),
        sampleValues = new Float32Array(kSplineTableSize);

    function A(a1, a2){return 1 - 3*a2 + 3*a1;}
    function B(a1, a2){return 3*a2 - 6*a1;}
    function C(a1){return 3*a1;}
    function calc(t,a1,a2){return ((A(a1,a2)*t + B(a1,a2))*t + C(a1))*t;}
    function slope(t,a1,a2){return 3*A(a1,a2)*t*t + 2*B(a1,a2)*t + C(a1);}

    for (var i=0;i<kSplineTableSize;++i) sampleValues[i]=calc(i*kSampleStepSize,mX1,mX2);

    function getTForX(x){
      var start=0, curr=1, last=kSplineTableSize-1;
      for(; curr!==last && sampleValues[curr]<=x; ++curr) start+=kSampleStepSize;
      --curr;
      var dist=(x - sampleValues[curr])/(sampleValues[curr+1]-sampleValues[curr]);
      var guess=start + dist*kSampleStepSize;
      var initSlope=slope(guess,mX1,mX2);
      if (initSlope >= NEWTON_MIN_SLOPE){
        for (var i=0;i<NEWTON_ITERATIONS;++i){
          var s=slope(guess,mX1,mX2); if (s===0) break;
          guess -= (calc(guess,mX1,mX2) - x)/s;
        }
        return guess;
      }
      if (initSlope===0) return guess;
      var a=start, b=start+kSampleStepSize, t, cx;
      for (var j=0;j<SUBDIVISION_MAX_ITERATIONS;++j){
        t = a + (b-a)/2;
        cx = calc(t,mX1,mX2) - x;
        if (Math.abs(cx) <= SUBDIVISION_PRECISION) break;
        (cx>0) ? (b=t) : (a=t);
      }
      return t;
    }

    return function(x){
      if (mX1===mY1 && mX2===mY2) return x;
      if (x<=0) return 0; if (x>=1) return 1;
      return calc(getTForX(x), mY1, mY2);
    };
  }
  var cssEase = cubicBezier(0.25, 0.10, 0.25, 1.00);
  $.easing.cssSmooth = function(_x, t, b, c, d){ return b + c * cssEase(t/d); };
})(jQuery);


/* -------------------------------------------------------------
 * 2) Tiny helper: temporarily disable CSS smooth scroll
 * ----------------------------------------------------------- */
function withSmoothDisabled(run) {
  var htmlEl = document.documentElement, bodyEl = document.body;
  var prevHtml = htmlEl.style.scrollBehavior, prevBody = bodyEl.style.scrollBehavior;
  var htmlSmooth = getComputedStyle(htmlEl).scrollBehavior === 'smooth';
  var bodySmooth = getComputedStyle(bodyEl).scrollBehavior === 'smooth';

  if (htmlSmooth) htmlEl.style.scrollBehavior = 'auto';
  if (bodySmooth) bodyEl.style.scrollBehavior = 'auto';
  try { run(); } finally {
    htmlEl.style.scrollBehavior = prevHtml || '';
    bodyEl.style.scrollBehavior = prevBody || '';
  }
}


/* -------------------------------------------------------------
 * 3) Smooth programmatic scroll (close to native feel)
 * ----------------------------------------------------------- */
window.madScrollTo = function(
  target,
  offsetSelectors = ['#wpadminbar', '.mad-navbar__section', '#brx-header.brx-sticky'],
  callback = null
){
  var $target;
  if (typeof target === 'string' && target.startsWith('#')) {
    var _el = document.getElementById(target.slice(1));
    $target = _el ? jQuery(_el) : jQuery();
  } else {
    $target = jQuery(target);
  }
  if (!$target.length) return;

  if (offsetSelectors == 'default') offsetSelectors = ['#wpadminbar', '.mad-navbar__section', '#brx-header.brx-sticky'];

  // prefers-reduced-motion → no animation
  var reduce = false;
  // try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(_){}

  var offset = 0;
  jQuery.each(offsetSelectors, function(_, sel){
    var $el = jQuery(sel); if ($el.length) offset += $el.outerHeight();
  });

  var y = $target.offset().top - offset;
  var max = Math.max(0, Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight);
  y = Math.max(0, Math.min(y, max));

  if (reduce){
    jQuery(document.scrollingElement || 'html, body').scrollTop(y);
    if (typeof callback === 'function') callback();
    return;
  }

  withSmoothDisabled(function(){
    var $el = jQuery(document.scrollingElement || document.documentElement);
    var start = $el.scrollTop();
    var dist  = Math.abs(y - start);
    var dur   = Math.round(Math.min(Math.max(dist * 0.45, 280), 550)); // native-ish

    let anim = true;
    const abort = function(){
      if (!anim) return;
      $el.stop(true, false);
      jQuery(window).off('.madScroll');
      anim = false;
    };
    jQuery(window).on('wheel.madScroll touchmove.madScroll keydown.madScroll', abort);

    $el.stop(true, false).animate(
      { scrollTop: y },
      dur,
      'cssSmooth',
      function(){
        if (!anim) return;
        jQuery(window).off('.madScroll');
        anim = false;
        if (typeof callback === 'function') callback();
      }
    );
  });
};


/* -------------------------------------------------------------
 * 4) Hash-on-load handler (smooth scroll, ScrollTrigger-safe)
 *    – Uses madScrollTo for smooth animation
 *    – Temporarily disables ScrollTrigger during scroll to prevent interruption
 *    – Re-enables and refreshes ScrollTrigger after scroll completes
 * ----------------------------------------------------------- */
(function(){
  var isPageLoadScroll = false;

  function jumpToHash(){
    var hash = window.location.hash;
    if (!hash || hash === '#' || hash === '#!') return;
    if (!document.getElementById(hash.slice(1))) return;

    // Flag that we're doing the initial page load scroll
    isPageLoadScroll = true;

    // Temporarily disable ScrollTrigger to prevent it from killing our animation
    var scrollTriggerWasEnabled = false;
    if (window.ScrollTrigger && typeof window.ScrollTrigger.getAll === 'function') {
      var triggers = window.ScrollTrigger.getAll();
      if (triggers.length > 0) {
        scrollTriggerWasEnabled = true;
        triggers.forEach(function(trigger){ trigger.disable(); });
      }
    }

    // Use madScrollTo for smooth animation
    window.madScrollTo(hash, 'default', function(){
      // Re-enable ScrollTrigger after scroll completes
      if (scrollTriggerWasEnabled && window.ScrollTrigger) {
        if (typeof window.ScrollTrigger.getAll === 'function') {
          window.ScrollTrigger.getAll().forEach(function(trigger){ trigger.enable(); });
        }
        if (typeof window.ScrollTrigger.refresh === 'function') {
          window.ScrollTrigger.refresh();
        }
      }

      // Update URL
      try {
        if (history.replaceState) {
          history.replaceState(null, '', hash);
        }
      } catch(_){}

      // Allow click handlers to work after a short delay
      setTimeout(function(){ isPageLoadScroll = false; }, 100);
    });
  }

  // Make the flag accessible to click handler
  window.__madScrollPageLoadFlag = function(){ return isPageLoadScroll; };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', jumpToHash, { once: true });
  } else {
    jumpToHash();
  }
})();


/* -------------------------------------------------------------
 * 5) Global hash link click handler (smooth scroll for all #links)
 *    – intercepts clicks on a[href^="#"] and same-page links with hashes
 *    – uses madScrollTo for smooth animation
 *    – updates URL after scroll completes
 * ----------------------------------------------------------- */
(function(){
  function initGlobalHashLinkHandler(){
    if (typeof window.madScrollTo !== 'function') return;

    document.addEventListener('click', function(e){
      // Don't interfere if we're still doing the initial page load scroll
      if (window.__madScrollPageLoadFlag && window.__madScrollPageLoadFlag()) return;

      // Don't interfere if another handler already prevented default
      if (e.defaultPrevented) return;

      // Find closest anchor tag
      var link = e.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href) return;

      var hash = null;

      // Case 1: Direct hash link (href="#section")
      if (href.startsWith('#')) {
        if (href === '#' || href === '#!') return;
        hash = href;
      }
      // Case 2: Full URL with hash (href="https://example.com/#section")
      else if (href.includes('#')) {
        try {
          var url = new URL(href, window.location.href);
          // Only handle if it's the same page (same origin and pathname)
          if (url.origin === window.location.origin &&
              url.pathname === window.location.pathname &&
              url.hash) {
            hash = url.hash;
          }
        } catch(_){
          // Invalid URL, ignore
          return;
        }
      }

      // If we don't have a hash to scroll to, let the browser handle it
      if (!hash) return;

      // Check if target exists on page
      if (!document.getElementById(hash.slice(1))) return;

      e.preventDefault();
      e.stopPropagation();

      // Smooth scroll using madScrollTo
      window.madScrollTo(hash, 'default', function(){
        // Update URL after scroll completes
        try {
          if (history.pushState) {
            history.pushState(null, '', hash);
          } else {
            window.location.hash = hash;
          }
        } catch(_){}
      });
    }, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalHashLinkHandler);
  } else {
    initGlobalHashLinkHandler();
  }
})();
